import { render, staticRenderFns } from "./RiderMediaCreate.vue?vue&type=template&id=ed4e6c16&lang=pug"
import script from "./RiderMediaCreate.vue?vue&type=script&lang=js"
export * from "./RiderMediaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports